document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.shubham-hero-slider');
  
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.shubham-slide');
    const prevBtn = slider.querySelector('.shubham-slider-prev');
    const nextBtn = slider.querySelector('.shubham-slider-next');
    const dots = slider.querySelectorAll('.shubham-slider-dot');
    
    // Do not initialize if there is only 1 slide
    if (slides.length <= 1) {
      if(slides[0]) slides[0].classList.add('is-active');
      return;
    }
    
    let currentIndex = 0;
    const totalSlides = slides.length;
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed) || 5000;
    let slideInterval;

    // Initialize first slide
    slides[currentIndex].classList.add('is-active');
    if(dots[currentIndex]) dots[currentIndex].classList.add('active');

    function updateSlider(newIndex) {
      // Remove active class from current
      slides[currentIndex].classList.remove('is-active');
      if(dots[currentIndex]) dots[currentIndex].classList.remove('active');
      
      // Add active class to new
      currentIndex = newIndex;
      slides[currentIndex].classList.add('is-active');
      if(dots[currentIndex]) dots[currentIndex].classList.add('active');
    }

    function nextSlide() {
      let newIndex = (currentIndex + 1) % totalSlides;
      updateSlider(newIndex);
    }

    function prevSlide() {
      let newIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlider(newIndex);
    }

    // Arrow Event Listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', () => { 
        nextSlide(); 
        resetInterval(); 
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => { 
        prevSlide(); 
        resetInterval(); 
      });
    }

    // Dot Event Listeners
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if(index !== currentIndex) {
          updateSlider(index);
          resetInterval();
        }
      });
    });

    // Autoplay Logic
    function startInterval() {
      if (autoplay) {
        slideInterval = setInterval(nextSlide, speed);
      }
    }

    function resetInterval() {
      clearInterval(slideInterval);
      startInterval();
    }

    // Start Autoplay
    startInterval();
  });
});